import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const EngineConfigAddCard = ({ onClick }) => {
  const { t } = useTranslation("common");

  return (
    <button type="button" className="engine-card add-card" onClick={onClick}>
      <div className="add-card-inner">
        <div className="add-card-icon">+</div>
        <div className="add-card-title">{t("Add Connection")}</div>
        <div className="add-card-sub">{t("Connect a new Odoo instance")}</div>
      </div>
    </button>
  );
};

EngineConfigAddCard.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default EngineConfigAddCard;
